import { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { FormDialog } from "@/components/kids/kidsUi";
import GlassPiggy, { ACCESSORIES, TINTS } from "@/components/piggy/GlassPiggy";

export default function StylePiggy({ hubId, kidId, style, balance, onClose, onSaved }) {
  const [tint, setTint] = useState(style.tint);
  const [accessory, setAccessory] = useState(style.accessory);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/organizations/${hubId}/piggy-bank/${kidId}/style`, { tint, accessory });
      toast.success("Your piggy looks great!");
      onSaved(data.style);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <FormDialog open onClose={onClose} title="Style my piggy" description="Pick a glass colour and something fun to wear." testid="piggy-style-dialog">
      <div className="flex justify-center rounded-2xl bg-q-raised py-3" data-testid="piggy-style-preview">
        <GlassPiggy balance={balance} tint={tint} accessory={accessory} size="md" testid="piggy-style-preview-piggy" />
      </div>
      <div>
        <p className="q-label">Glass</p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(TINTS).map(([id, t]) => (
            <button key={id} onClick={() => setTint(id)} aria-pressed={tint === id} data-testid={`piggy-tint-${id}`}
              className="inline-flex min-h-[48px] items-center gap-2 rounded-full border-2 px-3 text-sm font-bold text-q-text"
              style={{ borderColor: tint === id ? "rgb(var(--q-accent))" : "rgb(var(--q-border))" }}>
              <span className="h-6 w-6 rounded-full border border-white/40" style={{ background: `rgba(${t.rgb},0.75)` }} /> {t.label}
              {tint === id && <Check className="h-4 w-4 text-q-accent" />}
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="q-label">Accessory</p>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
          {Object.entries(ACCESSORIES).map(([id, label]) => (
            <button key={id} onClick={() => setAccessory(id)} aria-pressed={accessory === id} data-testid={`piggy-accessory-${id}`}
              className={`q-btn min-h-[48px] justify-center ${accessory === id ? "q-btn-primary" : "q-btn-secondary"}`}>{label}</button>
          ))}
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <button className="q-btn q-btn-ghost min-h-[48px]" onClick={onClose} data-testid="piggy-style-cancel-btn">Cancel</button>
        <button className="q-btn q-btn-primary min-h-[48px]" onClick={save} disabled={busy} data-testid="piggy-style-save-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Save my piggy</button>
      </div>
    </FormDialog>
  );
}
